import React from "react";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";

const FooterLink = styled(Link)`
  color: #a1a1a1;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;

  &:hover {
    color: #fff;
  }
`;
// ----------------------------------------------------
// Componente Flotante de WhatsApp
// ----------------------------------------------------
const WhatsAppFloat = styled.a`
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  z-index: 100;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background-color: #128c7e;
    transform: scale(1.1) rotate(10deg);
    color: #fff;
  }

  @media only screen and (max-width: 960px) {
    width: 48px;
    height: 48px;
    bottom: 25px;
    right: 25px;
    font-size: 26px;
  }
`;

// ----------------------------------------------------
// Estructura del Footer
// ----------------------------------------------------
const FooterContainer = styled.footer`
  width: 100%;
  background-color: #0b0b0b;
  color: #f8f9fa;
  padding: 4rem 1.5rem 1.5rem;
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 960px) {
    padding: 2.5rem 1rem 1rem;
  }
`;

const FooterGrid = styled.div`
  width: 100%;
  max-width: 1200px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  gap: 2.5rem;
  margin-bottom: 3rem;

  @media only screen and (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;

  h4 {
    font-size: 1.3rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 0.8rem;
    letter-spacing: 0.5px;
  }

  h5 {
    font-size: 1rem;
    font-weight: 600;
    color: #fff;
    margin-bottom: 1.2rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  p {
    font-size: 0.9rem;
    color: #a1a1a1;
    line-height: 1.5;
    margin-bottom: 1rem;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 0.6rem;
  }

  a {
    color: #a1a1a1;
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.2s ease;

    &:hover {
      color: #fff;
    }
  }
`;

const SnsLinks = styled.div`
  display: flex;
  gap: 1.2rem;
  margin-top: 0.5rem;

  @media only screen and (max-width: 960px) {
    justify-content: center;
  }

  a {
    color: #a1a1a1;
    font-size: 1.5rem;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-3px);
    }

    .fa-instagram:hover { color: #e4405f; }
    .fa-facebook:hover { color: #1877f2; }
    .fa-envelope:hover { color: #ea4335; }
  }
`;

const BottomBar = styled.div`
  width: 100%;
  max-width: 1200px;
  border-top: 1px solid #222;
  padding-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  color: #777;

  @media only screen and (max-width: 960px) {
    flex-direction: column;
    gap: 0.8rem;
    text-align: center;
  }
`;

// ----------------------------------------------------
// Componente principal
// ----------------------------------------------------
const Footer = () => {
  const navigate = useNavigate();

  const handleScrollToSection = (id) => {
    // Si no estamos en el inicio, primero vamos a '/'
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      // Si ya estamos en inicio, solo scrolleamos
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <FooterContainer>
        <FooterGrid>
          {/* Columna 1: Marca & Propuesta de valor */}
          <FooterColumn>
            <h4>Danyweb</h4>
            <p>Diseño y desarrollo web a medida. Creamos sitios modernos, optimizados y adaptados a tus necesidades para hacer crecer tu negocio.</p>
            <p style={{ fontSize: '0.8rem', color: '#fff' }}>TRABAJOS PARA TODA ARGENTINA</p>
            <SnsLinks>
              <a href="https://www.instagram.com/danyweb_24/?hl=es" target="_blank" rel="noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.facebook.com/danyweb.2024/" target="_blank" rel="noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook"></i>
              </a>
              <a href="mailto:disenosdanyweb@gmail.com" target="_blank" rel="noreferrer" aria-label="Email">
                <i className="fa fa-envelope"></i>
              </a>
            </SnsLinks>
          </FooterColumn>

          {/* Columna 2: Navegación Principal */}
         <FooterColumn>
  <h5>Navegación</h5>
  <ul>
    <li><FooterLink to="/">Inicio</FooterLink></li>
    <li><FooterLink to="/Promo">Servicios</FooterLink></li>
    <li><FooterLink to="/Trabajos">Clientes / Portafolio</FooterLink></li>
    <li><FooterLink to="/Nosotros">Nosotros</FooterLink></li>
    <li><FooterLink to="/contacto">Contacto</FooterLink></li>
    <li><FooterLink to="/Cotizador">Cotizar Proyecto</FooterLink></li>
  </ul>
</FooterColumn>
          {/* Columna 3: Enlaces Legales y FAQ */}
          <FooterColumn>
            <h5>Legales</h5>
            <ul>
              <li><a href="/terminos-y-condiciones">Términos y Condiciones</a></li>
              <li><a href="/politica-de-privacidad">Política de Privacidad</a></li>
              <li><a href="/faq">Preguntas Frecuentes</a></li>
            </ul>
          </FooterColumn>

          {/* Columna 4: Datos de Contacto Directo */}
          <FooterColumn>
            <h5>Contacto</h5>
            <p style={{ marginBottom: '0.4rem' }}>📍 Buenos Aires, Argentina</p>
            <p style={{ marginBottom: '0.4rem' }}>✉️ disenosdanyweb@gmail.com</p>
            <p style={{ marginBottom: '0.4rem' }}>📱 +54 9 11 25528283</p>
          </FooterColumn>
        </FooterGrid>

        {/* Barra Inferior de Copyright */}
        <BottomBar>
          <p>© 2022 Danyweb. Todos los derechos reservados.</p>
          <p>Bs As, Argentina</p>
        </BottomBar>
      </FooterContainer>

      {/* Botón flotante de WhatsApp */}
      <WhatsAppFloat 
        href="https://wa.me/5491125528283" 
        target="_blank" 
        rel="noreferrer"
        aria-label="Contactar por WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </WhatsAppFloat>
    </>
  );
};

export default Footer;